import React, { useEffect, useState } from 'react';
import usePushNotifications from './hooks/usePushNotifications';
import { Container, Form, Button, Image } from 'react-bootstrap';
import './App.css';
import './config/config';
import Login from './screens/Login';
import Dashboard from './screens/Dashboard';
import ProjectDashboard from './screens/ProjectDashboard';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateComponent from './screens/PrivateComponent';
import Settings from './screens/Settings';
import ProjectOverview from './screens/ProjectOverview';
import SingleProject from './screens/SingleProject';
import NotificationList from './components/NotificationList';
import Calendar from './screens/Calendar';
import MyTask from './screens/MyTask';
// import RequestPermission from './RequestPermission';
import ReportProjectOverview from './screens/ReportProjectOverview';
import DesignersOverview from './screens/DesignersOverview';
import SalesReports from './screens/SalesReports';
import RacingTrackBoard from './screens/RacingTrackBoard';
import Leads from './screens/Leads';
import LeadsDetails from './screens/LeadsDetails';
import Test from './components/test.js';

const App = () => {
  // Use state for reactive role updates
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const role = window.localStorage.getItem('projectUserRole');
    setUserRole(role);
    setIsLoading(false);
  }, []);



  // Listen for storage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const role = window.localStorage.getItem('projectUserRole');
      setUserRole(role);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const RoleRoute = ({ children, allowedRoles }) => {
    // Wait for loading to complete
    if (isLoading) {
      return <div>Loading...</div>;
    }

    // Get fresh role data
    const currentRole = userRole || window.localStorage.getItem('projectUserRole');
    
    if (!currentRole) {
      console.log('No user role found');
      return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(currentRole)) {
      console.log(`Access denied. User role: ${currentRole}, Required: ${allowedRoles.join(', ')}`);
      return <Navigate to="/" replace />;
    }

    return children;
  };

  return (
    <>
      {/* 🔔 Firebase Push Notification Setup */}
      {/* <RequestPermission /> */}

      {/* 🧭 App Routing */}
      <Routes>
        {/* Protected Routes wrapped in PrivateComponent */}
        <Route element={<PrivateComponent />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/leads/:leadId" element={<LeadsDetails />} />
          <Route path="/projects" element={<ProjectDashboard />} />
          <Route path="/project/:projectId" element={<ProjectOverview />} />
          <Route path="/my-task" element={<MyTask />} /> 
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/sales-report" element={<SalesReports />} />
          <Route path="/champions-board" element={<RacingTrackBoard />} />
          <Route path="/settings" element={<Settings />} />
          
          {/* Role-based routes */}
          <Route 
            path="/projects-overview" 
            element={
              <RoleRoute allowedRoles={['admin', 'salesHead', 'designerHead','executionHead']}>
                <ReportProjectOverview />
              </RoleRoute>
            } 
          />
          
          <Route 
            path="/designers-overview" 
            element={
              <RoleRoute allowedRoles={['admin', 'designerHead']}>
                <DesignersOverview />
              </RoleRoute>
            } 
          />
        </Route>
        
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/test" element={<Test />} />
        
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default App;